var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dashboardTableLoading || _vm.loading,
              expression: "dashboardTableLoading || loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            border: "",
            "max-height": _vm.tableHeight,
            "header-cell-class-name": _vm.tableHeaderCls,
            "show-summary": "",
            "summary-method": _vm.getSummaries,
            size: "mini",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              prop: "target",
              label: "",
              align: "left",
              "show-overflow-tooltip": "",
              width: "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "initiated",
              label: _vm.$t("ECHANGE_STATUS._1"),
              align: "center",
              "min-width": "125",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "submittedToGroup",
              label: _vm.$t("ECHANGE_STATUS._2"),
              align: "center",
              "min-width": "125",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "revisionRequired",
              label: _vm.$t("ECHANGE_STATUS._3"),
              align: "center",
              "min-width": "125",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "approvedByGroupTeam",
              label: _vm.$t("ECHANGE_STATUS._4"),
              align: "center",
              "min-width": "125",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "total",
              label: _vm.$t("DASHBOARD_TOTAL"),
              align: "center",
              "min-width": "100",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }